"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearlyScheduleControlModel = void 0;
const core_1 = require("@veeam/core");
const types_1 = require("../types");
class YearlyScheduleControlModel extends core_1.Model {
    constructor(initialValue) {
        super(initialValue);
        this.isOnDay = () => {
            return this.getValue().fieldDayNumberInMonthValue === types_1.DAY_NUMBER_IN_MONTH.onDay;
        };
    }
}
exports.YearlyScheduleControlModel = YearlyScheduleControlModel;
//# sourceMappingURL=YearlyScheduleControlModel.js.map